<script lang="ts">
  import { Eye, EyeOff } from "lucide-svelte"

  interface Props {
    class?: string
    placeholder?: string
    value?: string
    name?: string
    id?: string
    required?: boolean
  }

  let {
    class: css = "input bg-white text-black",
    placeholder = "**********",
    id = "password",
    name = "password",
    value = $bindable(""),
    required = true
  }: Props = $props()

  let show = $state(false)

  function setValue(e: any): void {
    value = e.target.value
  }
</script>

<div class="relative">
  {#if show}
    <input
      type="text"
      bind:value
      {name}
      {id}
      class={css}
      {placeholder}
      oninput={setValue}
    />
  {:else}
    <input
      type="password"
      {value}
      name="password"
      {required}
      class={css}
      {placeholder}
      oninput={setValue}
    />
  {/if}
  <button
    type="button"
    class="absolute top-2 right-3"
    onclick={() => {
      show = !show
    }}
  >
    {#if show}
      <EyeOff class="text-slate-500" />
    {:else}
      <Eye class="text-slate-500" />
    {/if}
  </button>
</div>
